import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Text } from '../text';
import { View } from './tw-wrappers';

interface LevelLabelsProps {
  fontSize?: number;
  color?: string;
}

export function LevelLabels({ fontSize = 8, color = '#99a1af' }: LevelLabelsProps) {
  const { t } = useTranslation();

  return (
    <View className="flex-row justify-between px-1">
      <Text style={{ ...styles.levelText, fontSize, color }} type='default' >
        {t('common.levels.low')}
      </Text>
      <Text style={{ ...styles.levelText, fontSize, color }} type='default'>
        {t('common.levels.medium')}
      </Text>
      <Text style={{ ...styles.levelText, fontSize, color }} type='default'>
        {t('common.levels.high')}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  levelText: {
    lineHeight: 10,
    fontSize: 8,
    color: '#99a1af'
  },
});
